export const init = () => {
    const $ = jQuery;

    const initCarousel = () => {
        $('.section-feature-collection').each(function () {
            const $section = $(this);
            const $carousel = $section.find('.owl-carousel');

            const carousel = $carousel.owlCarousel({
                items: 1,
                center: false,
                loop: false,
                margin: 8,
                nav: false,
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2,
                        margin: 16
                    },
                    992: {
                        items: 4,
                        margin: 16
                    },
                },
            });

            $section.find('.left-item-carousel').on('click', function (e) {
                e.preventDefault();
                carousel.trigger('prev.owl.carousel');
                return false;
            });

            $section.find('.right-item-carousel').on('click', function (e) {
                e.preventDefault();
                carousel.trigger('next.owl.carousel');
                return false;
            });
        });
    };

    initCarousel();
};
